var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { on: { submit: _vm.submit } },
    [
      _c(
        "v-banner",
        { staticClass: "opportunity-user-input", attrs: { sticky: "" } },
        [
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_date"
              ),
              "detail-value": [_vm.parseDate(_vm.form["applyInfoApplyDate"])]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_seihin"
              ),
              "detail-value": [
                _vm.$t("view.sales_force.reflect.label.contract.kobetu")
              ]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_period"
              ),
              "detail-value": [_vm.getPlanName()]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_ninsu"
              ),
              "detail-value": [_vm.form["applyInfoApplyCapacity"]]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.contract_form.update.label.apply_info.start_date"
              ),
              "detail-value": [
                _vm.parseDate(_vm.form["applyInfoKinoKunrenStartDate"])
              ]
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-expansion-panels",
        {
          attrs: { accordion: "", flat: "", multiple: "" },
          model: {
            value: _vm.salesForceInfo.useKobetuFreePeriod,
            callback: function($$v) {
              _vm.$set(_vm.salesForceInfo, "useKobetuFreePeriod", $$v)
            },
            expression: "salesForceInfo.useKobetuFreePeriod"
          }
        },
        [
          _c(
            "v-expansion-panel",
            { attrs: { readonly: "" } },
            [
              _c(
                "v-expansion-panel-header",
                { staticClass: "pa-0 mt-0" },
                [
                  _c("v-checkbox", {
                    attrs: { value: "true", "hide-details": "" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function() {
                          return [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "apply-service-label text-black font-weight-bold subtitle-1"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "view.sales_force.reflect.button_caption.add_opportunity"
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.useKobetuFreePeriod,
                      callback: function($$v) {
                        _vm.useKobetuFreePeriod = $$v
                      },
                      expression: "useKobetuFreePeriod"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.free_opportunity_id"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "8", md: "4" }
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "mt-0 pt-0 pb-0",
                            attrs: {
                              "persistent-hint": "",
                              hint: _vm.$t(
                                "view.sales_force.reflect.hint.opportunity.opportunity_id"
                              ),
                              placeholder: _vm.$t(
                                "view.sales_force.reflect.placeholder.opportunity.opportunity_id"
                              ),
                              autocomplete: "off"
                            },
                            model: {
                              value: _vm.salesForceInfo.freeOpportunityKobetuId,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "freeOpportunityKobetuId",
                                  $$v
                                )
                              },
                              expression:
                                "salesForceInfo.freeOpportunityKobetuId"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
                          attrs: { cols: "12", sm: "4", md: "4" }
                        },
                        [
                          _c("move-sales-force-button", {
                            attrs: {
                              "sales-force-id":
                                _vm.salesForceInfo.freeOpportunityKobetuId,
                              "sales-force-type": "Opportunity"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.free_opportunity_item_id"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "8", md: "4" }
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "mt-0 pt-0 pb-0",
                            attrs: {
                              "persistent-hint": "",
                              hint: _vm.$t(
                                "view.sales_force.reflect.hint.opportunity.opportunity_line_item_id"
                              ),
                              placeholder: _vm.$t(
                                "view.sales_force.reflect.placeholder.opportunity.opportunity_line_item_id"
                              ),
                              autocomplete: "off"
                            },
                            model: {
                              value:
                                _vm.salesForceInfo.freeOpportunityKobetuItemId,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "freeOpportunityKobetuItemId",
                                  $$v
                                )
                              },
                              expression:
                                "salesForceInfo.freeOpportunityKobetuItemId"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
                          attrs: { cols: "12", sm: "4", md: "4" }
                        },
                        [
                          _c("move-sales-force-button", {
                            attrs: {
                              "sales-force-id":
                                _vm.salesForceInfo.freeOpportunityKobetuItemId,
                              "sales-force-type": "OpportunityLineItem"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.free_opportunity_name"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "8", md: "4" }
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "mt-0 pt-0 pb-0",
                            attrs: {
                              "persistent-hint": "",
                              hint: _vm.$t(
                                "view.sales_force.reflect.hint.opportunity.opportunity_name"
                              ),
                              placeholder: _vm.$t(
                                "view.sales_force.reflect.placeholder.opportunity.opportunity_name"
                              ),
                              autocomplete: "off"
                            },
                            model: {
                              value:
                                _vm.salesForceInfo.freeOpportunityKobetuName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "freeOpportunityKobetuName",
                                  $$v
                                )
                              },
                              expression:
                                "salesForceInfo.freeOpportunityKobetuName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.price_book.price_book_select_free"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "12", md: "5" }
                        },
                        [
                          _c("price-book-select", {
                            attrs: { "price-book-items": _vm.priceBookData },
                            on: {
                              "price-book-change": _vm.freePriceBookChange
                            },
                            model: {
                              value: _vm.salesForceInfo.kobetuFreePriceBook2Id,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "kobetuFreePriceBook2Id",
                                  $$v
                                )
                              },
                              expression:
                                "salesForceInfo.kobetuFreePriceBook2Id"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.cancel_flg"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "12", md: "5" }
                        },
                        [
                          _c("v-checkbox", {
                            staticClass: "mt-0",
                            attrs: {
                              "persistent-hint": "",
                              disabled: _vm.isCancelFlgDisable(),
                              "input-value":
                                _vm.salesForceInfo.kobetuCancelFlag,
                              value: _vm.$t(
                                "view.sales_force.reflect.data_labels.contract.cancel_flg.value"
                              ),
                              label: _vm.$t(
                                "view.sales_force.reflect.data_labels.contract.cancel_flg.label"
                              )
                            },
                            model: {
                              value: _vm.salesForceInfo.kobetuCancelFlag,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "kobetuCancelFlag",
                                  $$v
                                )
                              },
                              expression: "salesForceInfo.kobetuCancelFlag"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.product_free"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "12", md: "5" }
                        },
                        [
                          _c("product-select", {
                            attrs: {
                              "price-book-id":
                                _vm.salesForceInfo.kobetuFreePriceBook2Id,
                              product: _vm.$t(
                                "view.sales_force.reflect.label.opportunity.kobetu"
                              ),
                              capacity: _vm.form.applyInfoApplyCapacity,
                              period: _vm.getSalesForcePeriod()
                            },
                            on: { "product-change": _vm.freeProductChange },
                            model: {
                              value: _vm.salesForceInfo.kobetuFreeProductId,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "kobetuFreeProductId",
                                  $$v
                                )
                              },
                              expression: "salesForceInfo.kobetuFreeProductId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.free_period"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "12", md: "5" }
                        },
                        [
                          _c("free-period", {
                            on: { input: _vm.periodChange },
                            model: {
                              value: _vm.salesForceInfo.kobetuFreePeriod,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "kobetuFreePeriod",
                                  $$v
                                )
                              },
                              expression: "salesForceInfo.kobetuFreePeriod"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                          attrs: { cols: "12", sm: "12", md: "4" }
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "pt-3 pb-3 align-center fixed-label-area",
                              attrs: { color: "grey lighten-3" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "mb-0 font-weight-bold ml-4 fixed-label"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.sales_force.reflect.label.opportunity.free_start_date"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-2 pb-0",
                          attrs: { cols: "12", sm: "12", md: "5" }
                        },
                        [
                          _c("date-picker-wrapper", {
                            attrs: {
                              classes: "mt-0 pt-0 pb-0",
                              disabled: true,
                              type: "date"
                            },
                            model: {
                              value:
                                _vm.salesForceInfo.freeKobetuContractStartDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesForceInfo,
                                  "freeKobetuContractStartDate",
                                  $$v
                                )
                              },
                              expression:
                                "salesForceInfo.freeKobetuContractStartDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider", { staticClass: "mt-2" }),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.opportunity_id"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "8", md: "4" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.opportunity.opportunity_id"
                  ),
                  placeholder: _vm.$t(
                    "view.sales_force.reflect.placeholder.opportunity.opportunity_id"
                  ),
                  autocomplete: "off"
                },
                model: {
                  value: _vm.salesForceInfo.opportunityKobetuId,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "opportunityKobetuId", $$v)
                  },
                  expression: "salesForceInfo.opportunityKobetuId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
              attrs: { cols: "12", sm: "4", md: "4" }
            },
            [
              _c("move-sales-force-button", {
                attrs: {
                  "sales-force-id": _vm.salesForceInfo.opportunityKobetuId,
                  "sales-force-type": "Opportunity"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.opportunity_line_item_id"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "8", md: "4" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.opportunity.opportunity_line_item_id"
                  ),
                  placeholder: _vm.$t(
                    "view.sales_force.reflect.placeholder.opportunity.opportunity_line_item_id"
                  ),
                  autocomplete: "off"
                },
                model: {
                  value: _vm.salesForceInfo.opportunityKobetuItemId,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "opportunityKobetuItemId", $$v)
                  },
                  expression: "salesForceInfo.opportunityKobetuItemId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
              attrs: { cols: "12", sm: "4", md: "4" }
            },
            [
              _c("move-sales-force-button", {
                attrs: {
                  "sales-force-id": _vm.salesForceInfo.opportunityKobetuItemId,
                  "sales-force-type": "OpportunityLineItem"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.opportunity_name"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "8", md: "4" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.opportunity.opportunity_name"
                  ),
                  placeholder: _vm.$t(
                    "view.sales_force.reflect.placeholder.opportunity.opportunity_name"
                  ),
                  autocomplete: "off"
                },
                model: {
                  value: _vm.salesForceInfo.opportunityKobetuName,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "opportunityKobetuName", $$v)
                  },
                  expression: "salesForceInfo.opportunityKobetuName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.price_book.price_book_select"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("price-book-select", {
                attrs: { "price-book-items": _vm.priceBookData },
                model: {
                  value: _vm.salesForceInfo.kobetuPriceBook2Id,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "kobetuPriceBook2Id", $$v)
                  },
                  expression: "salesForceInfo.kobetuPriceBook2Id"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.product"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("product-select", {
                attrs: {
                  "price-book-id": _vm.salesForceInfo.kobetuPriceBook2Id,
                  product: _vm.$t(
                    "view.sales_force.reflect.label.opportunity.kobetu"
                  ),
                  capacity: _vm.form.applyInfoApplyCapacity,
                  period: _vm.getSalesForcePeriod()
                },
                on: {
                  "price-change": _vm.kobetuPriceChange,
                  "product-change": _vm.productChange,
                  "entry-change": _vm.entryChange
                },
                model: {
                  value: _vm.salesForceInfo.kobetuProductId,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "kobetuProductId", $$v)
                  },
                  expression: "salesForceInfo.kobetuProductId"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.unit_price"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "10", sm: "10", md: "5" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  disabled: "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.price_input_base"
                  ),
                  autocomplete: "off",
                  type: "number",
                  suffix: _vm.$t("view.sales_force.reflect.label.contract.yen")
                },
                model: {
                  value: _vm.kobetuPrice,
                  callback: function($$v) {
                    _vm.kobetuPrice = $$v
                  },
                  expression: "kobetuPrice"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.price"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  "error-messages": _vm.getPriceErrorMsg(),
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.price_kobetu"
                  ),
                  autocomplete: "off",
                  type: "number",
                  suffix: _vm.$t("view.sales_force.reflect.label.contract.yen")
                },
                model: {
                  value: _vm.salesForceInfo.kobetuPrice,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "kobetuPrice", $$v)
                  },
                  expression: "salesForceInfo.kobetuPrice"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.apply_start_date"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  disabled: true,
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.apply_start_date"
                  ),
                  type: "date"
                },
                model: {
                  value: _vm.salesForceInfo.kobetuContractStartDate,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "kobetuContractStartDate", $$v)
                  },
                  expression: "salesForceInfo.kobetuContractStartDate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.request_start_date"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.request_start_date"
                  ),
                  type: "date"
                },
                model: {
                  value: _vm.salesForceInfo.kobetuRequestStartDate,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "kobetuRequestStartDate", $$v)
                  },
                  expression: "salesForceInfo.kobetuRequestStartDate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.contract_edate"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.contract_edate"
                  ),
                  type: "date"
                },
                model: {
                  value: _vm.salesForceInfo.kobetuContractEdate,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "kobetuContractEdate", $$v)
                  },
                  expression: "salesForceInfo.kobetuContractEdate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3  align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.bunkatsu"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-checkbox", {
                staticClass: "mt-0",
                attrs: {
                  "persistent-hint": "",
                  "input-value": _vm.salesForceInfo.kobetuBunkatuFlg,
                  value: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.bunkatsu.value"
                  ),
                  label: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.bunkatsu.label"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.kobetuBunkatuFlg,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "kobetuBunkatuFlg", $$v)
                  },
                  expression: "salesForceInfo.kobetuBunkatuFlg"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3  align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.it_flg"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-checkbox", {
                staticClass: "mt-0",
                attrs: {
                  "persistent-hint": "",
                  "input-value": _vm.salesForceInfo.kobetuItFlg,
                  value: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.it_flg.value"
                  ),
                  label: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.it_flg.label"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.kobetuItFlg,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "kobetuItFlg", $$v)
                  },
                  expression: "salesForceInfo.kobetuItFlg"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 fixed-label-area align-center",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold fixed-label ml-4" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.tokubetu_detail"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-textarea", {
                staticClass: "mt-0",
                attrs: {
                  outlined: "",
                  rows: "2",
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.tokubetu_detail"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.kobetuTokubetuDetail,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "kobetuTokubetuDetail", $$v)
                  },
                  expression: "salesForceInfo.kobetuTokubetuDetail"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("sales-force-button-area", {
        attrs: { "disable-csv-output": true },
        on: { reflect: _vm.submit, "re-correct": _vm.reCorrect }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showConfirmDialog,
          "max-width": "800",
          "default-msg": _vm.confirmMessage
        },
        on: {
          "ok-click": function($event) {
            return _vm.reflect()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showAlertDialog,
          "max-width": "800",
          "is-confirm": false,
          "default-msg": _vm.alertMessage
        },
        on: {
          "ok-click": function($event) {
            return _vm.dialogClose()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f110a078", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f110a078","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales_force/OpportunityKobetu.vue
// module id = Uhrd
// module chunks = 1